import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { PortfolioTableModule } from '@components';

import { SharedModule } from '../../shared.module';
import {
  AtAGlanceComponent,
  HeaderComponent,
  ModalStageComponent,
  NotificationCardComponent,
  SummaryCardComponent,
  ToolsCardComponent
} from './components';
import { HomeComponent } from './home.component';

@NgModule({
  declarations: [
    HomeComponent,
    AtAGlanceComponent,
    NotificationCardComponent,
    HeaderComponent,
    SummaryCardComponent,
    ToolsCardComponent,
    ModalStageComponent
  ],
  exports: [HomeComponent],
  imports: [
    CommonModule,
    OverlayModule,
    SharedModule,
    MatDividerModule,
    MatIconModule,
    RouterModule,
    PortfolioTableModule
  ]
})
export class HomeModule {}
